import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

import { BautagebuchDialogData } from '../../models/bautagebuch-dialog-data.model';

@Component({
  standalone: false,
  selector: 'app-bautagebuch-gu-legacy-form-bridge',
  templateUrl: './bautagebuch-gu-legacy-form-bridge.component.html',
  styleUrls: ['./bautagebuch-gu-legacy-form-bridge.component.scss']
})
export class BautagebuchGuLegacyFormBridgeComponent {
  constructor(@Inject(MAT_DIALOG_DATA) public readonly data: BautagebuchDialogData) {}
}
